import { render } from "./DashboardChartCard.vue?vue&type=template&id=3f409336&scoped=true"
import script from "./DashboardChartCard.vue?vue&type=script&lang=js"
export * from "./DashboardChartCard.vue?vue&type=script&lang=js"

import "./DashboardChartCard.vue?vue&type=style&index=0&id=3f409336&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f409336"]])

export default __exports__